import React from 'react';
import { GraduationCap, Languages } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const FALLBACK_TEAM = [
  {
    id: 't1',
    name: 'Dr. Mehmet Yılmaz',
    role: 'Implantology · DDS',
    avatar: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=600&q=80',
    education: 'Istanbul University · 12+ years experience',
    languages: 'EN · TR · DE',
  },
  {
    id: 't2',
    name: 'Dr. Ayşe Demir',
    role: 'Cosmetic & Aesthetic Dentistry',
    avatar: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=600&q=80',
    education: 'Hacettepe University · 10+ years experience',
    languages: 'EN · TR · RU',
  },
  {
    id: 't3',
    name: 'Dr. Can Aydın',
    role: 'Orthodontics · Invisalign Provider',
    avatar: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=600&q=80',
    education: 'Marmara University · 8+ years experience',
    languages: 'EN · TR · NO',
  },
];

export default function TeamSection({ members = FALLBACK_TEAM }) {
  const { t } = useLanguage();

  return (
    <section id="team" className="section-padding section-tone-a">
      <div className="container-premium">
        <div className="section-head">
          <span className="section-eyebrow">{t('team.eyebrow', 'Meet our experts')}</span>
          <h2 className="section-title">{t('team.title', 'The Crystal Dental Team')}</h2>
          <p className="section-sub">
            {t('team.subtitle', 'Internationally trained specialists committed to your comfort and care.')}
          </p>
        </div>

        <div className="grid-3 team-grid">
          {members.map((m) => (
            <article key={m.id} className="team-card">
              <div className="team-avatar">
                <img src={m.avatar} alt={m.name} loading="lazy" />
              </div>
              <div className="team-body">
                <h3>{m.name}</h3>
                <p className="team-role">{m.role}</p>
                <ul className="team-meta">
                  {m.education && (
                    <li>
                      <GraduationCap size={14} /> {m.education}
                    </li>
                  )}
                  {m.languages && (
                    <li>
                      <Languages size={14} /> {t('team.languages', 'Speaks')}: {m.languages}
                    </li>
                  )}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
